/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ApproveProjectItemsCommand } from '../../models/approve-project-items-command';
import { ApproveProjectItemsCommandResult } from '../../models/approve-project-items-command-result';

export interface ApiProjectApproveProjectItemsPatch$Plain$Params {
      body?: ApproveProjectItemsCommand
}

export function apiProjectApproveProjectItemsPatch$Plain(http: HttpClient, rootUrl: string, params?: ApiProjectApproveProjectItemsPatch$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<ApproveProjectItemsCommandResult>> {
  const rb = new RequestBuilder(rootUrl, apiProjectApproveProjectItemsPatch$Plain.PATH, 'patch');
  if (params) {
    rb.body(params.body, 'application/*+json');
  }

  return http.request(
    rb.build({ responseType: 'text', accept: 'text/plain', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<ApproveProjectItemsCommandResult>;
    })
  );
}

apiProjectApproveProjectItemsPatch$Plain.PATH = '/api/Project/ApproveProjectItems';
